/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VatType = exports.V2FilterByFilterType = exports.TranslatableType = exports.SubdivisionType = exports.ServiceFilterByFilterType = exports.ServiceAppendixType = exports.Proximity = exports.ProvidersNames = exports.PermissionType = exports.PagingType = exports.OptimizeMode = exports.Method = exports.MessageAppendixType = exports.Maturity = exports.Label = exports.JSType = exports.Format = exports.FieldDescriptorProtoType = exports.Exposure = exports.CType = void 0;
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var FieldDescriptorProtoType;
(function (FieldDescriptorProtoType) {
    FieldDescriptorProtoType["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    FieldDescriptorProtoType["TYPE_FLOAT"] = "TYPE_FLOAT";
    FieldDescriptorProtoType["TYPE_INT64"] = "TYPE_INT64";
    FieldDescriptorProtoType["TYPE_UINT64"] = "TYPE_UINT64";
    FieldDescriptorProtoType["TYPE_INT32"] = "TYPE_INT32";
    FieldDescriptorProtoType["TYPE_FIXED64"] = "TYPE_FIXED64";
    FieldDescriptorProtoType["TYPE_FIXED32"] = "TYPE_FIXED32";
    FieldDescriptorProtoType["TYPE_BOOL"] = "TYPE_BOOL";
    FieldDescriptorProtoType["TYPE_STRING"] = "TYPE_STRING";
    FieldDescriptorProtoType["TYPE_GROUP"] = "TYPE_GROUP";
    FieldDescriptorProtoType["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    FieldDescriptorProtoType["TYPE_BYTES"] = "TYPE_BYTES";
    FieldDescriptorProtoType["TYPE_UINT32"] = "TYPE_UINT32";
    FieldDescriptorProtoType["TYPE_ENUM"] = "TYPE_ENUM";
    FieldDescriptorProtoType["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    FieldDescriptorProtoType["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    FieldDescriptorProtoType["TYPE_SINT32"] = "TYPE_SINT32";
    FieldDescriptorProtoType["TYPE_SINT64"] = "TYPE_SINT64";
})(FieldDescriptorProtoType = exports.FieldDescriptorProtoType || (exports.FieldDescriptorProtoType = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var MessageAppendixType;
(function (MessageAppendixType) {
    MessageAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    MessageAppendixType["AUTO_VELO"] = "AUTO_VELO";
    MessageAppendixType["DOCS_CONF"] = "DOCS_CONF";
    MessageAppendixType["MULTILINGUAL"] = "MULTILINGUAL";
})(MessageAppendixType = exports.MessageAppendixType || (exports.MessageAppendixType = {}));
var Method;
(function (Method) {
    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    Method["CREATE"] = "CREATE";
    Method["GET_ITEM"] = "GET_ITEM";
    Method["UPDATE"] = "UPDATE";
    Method["DELETE"] = "DELETE";
    Method["UPSERT"] = "UPSERT";
    Method["LIST"] = "LIST";
    Method["QUERY"] = "QUERY";
    Method["BULK_CREATE"] = "BULK_CREATE";
    Method["BULK_UPDATE"] = "BULK_UPDATE";
    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
    Method["BULK_DELETE"] = "BULK_DELETE";
    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
    Method["BULK_UPSERT"] = "BULK_UPSERT";
})(Method = exports.Method || (exports.Method = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var PagingType;
(function (PagingType) {
    PagingType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    PagingType["OFFSET"] = "OFFSET";
    PagingType["CURSOR"] = "CURSOR";
})(PagingType = exports.PagingType || (exports.PagingType = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["AUTO"] = "AUTO";
    PermissionType["MANUAL"] = "MANUAL";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var ProvidersNames;
(function (ProvidersNames) {
    ProvidersNames["Google"] = "Google";
    ProvidersNames["Apple"] = "Apple";
})(ProvidersNames = exports.ProvidersNames || (exports.ProvidersNames = {}));
var Proximity;
(function (Proximity) {
    Proximity["UNKNOWN_PROXIMITY"] = "UNKNOWN_PROXIMITY";
    Proximity["PINPOINT"] = "PINPOINT";
    Proximity["APPROXIMATE"] = "APPROXIMATE";
    Proximity["GENERAL_AREA"] = "GENERAL_AREA";
})(Proximity = exports.Proximity || (exports.Proximity = {}));
var ServiceAppendixType;
(function (ServiceAppendixType) {
    ServiceAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    ServiceAppendixType["NILE"] = "NILE";
    ServiceAppendixType["MESSAGE_BUS"] = "MESSAGE_BUS";
})(ServiceAppendixType = exports.ServiceAppendixType || (exports.ServiceAppendixType = {}));
var ServiceFilterByFilterType;
(function (ServiceFilterByFilterType) {
    ServiceFilterByFilterType["zip_code"] = "zip_code";
    ServiceFilterByFilterType["country_code"] = "country_code";
})(ServiceFilterByFilterType = exports.ServiceFilterByFilterType || (exports.ServiceFilterByFilterType = {}));
var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType = exports.SubdivisionType || (exports.SubdivisionType = {}));
var TranslatableType;
(function (TranslatableType) {
    TranslatableType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TranslatableType["SHORT_TEXT"] = "SHORT_TEXT";
    TranslatableType["LONG_TEXT"] = "LONG_TEXT";
    TranslatableType["RICH_TEXT"] = "RICH_TEXT";
    TranslatableType["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
    TranslatableType["SELECTION"] = "SELECTION";
    TranslatableType["MULTI_SELECTION"] = "MULTI_SELECTION";
    TranslatableType["DOCUMENT"] = "DOCUMENT";
    TranslatableType["IMAGE"] = "IMAGE";
    TranslatableType["VIDEO"] = "VIDEO";
})(TranslatableType = exports.TranslatableType || (exports.TranslatableType = {}));
var V2FilterByFilterType;
(function (V2FilterByFilterType) {
    V2FilterByFilterType["zip_code"] = "zip_code";
    V2FilterByFilterType["country_code"] = "country_code";
})(V2FilterByFilterType = exports.V2FilterByFilterType || (exports.V2FilterByFilterType = {}));
var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    VatType["CPF"] = "CPF";
    VatType["CNPJ"] = "CNPJ";
})(VatType = exports.VatType || (exports.VatType = {}));
//# sourceMappingURL=types.js.map